module.exports = {
  NO_PREFERENCE: 'no-preference',
  VEGAN: 'vegan',
  VEGETARIAN: 'vegetarian',
};
